import { render, staticRenderFns } from "./PublicMenus.vue?vue&type=template&id=3908a5e0&"
import script from "./PublicMenus.vue?vue&type=script&lang=js&"
export * from "./PublicMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PublicMenus.vue"
export default component.exports